package com.example.mystybag.appCore.model

data class NotificationSettingsUIState(
    val discountsAndNewsPushEnabled: Boolean = true,
    val discountsAndNewsEmailEnabled: Boolean = false,
    val reservationCompletedPushEnabled: Boolean = true,
    val reservationCompletedEmailEnabled: Boolean = false
)
